import {
  isSameProductLink,
  isSameVariantLink,
  matchesProductLinkFilter,
  matchesVariantLinkFilter,
} from './productLinkMatchers';

const filterProductLinks = (products = [], filters = []) => {
  if (!filters.length) return products;
  return products.filter((link) => !filters.some((filter) => matchesProductLinkFilter(link, filter)));
};

const filterVariantLinks = (productVariants = [], filters = []) => {
  if (!filters.length) return productVariants;
  return productVariants.filter(
    (link) => !filters.some((filter) => matchesVariantLinkFilter(link, filter)),
  );
};

const decrementAggregatedProductLinks = (products = [], filters = [], selectedAffectedCount = 0) => {
  if (!filters.length || !selectedAffectedCount) return products;

  return products
    .map((link) => {
      const matched = filters.some((filter) => isSameProductLink(link, filter));
      if (!matched) return link;

      const newCount = (link.numberOfAssets || 1) - selectedAffectedCount;
      if (newCount <= 0) return null;
      return { ...link, numberOfAssets: newCount };
    })
    .filter(Boolean);
};

const decrementAggregatedVariantLinks = (productVariants = [], filters = [], selectedAffectedCount = 0) => {
  if (!filters.length || !selectedAffectedCount) return productVariants;

  return productVariants
    .map((link) => {
      const matched = filters.some((filter) => isSameVariantLink(link, filter));
      if (!matched) return link;

      const newCount = (link.numberOfAssets || 1) - selectedAffectedCount;
      if (newCount <= 0) return null;
      return { ...link, numberOfAssets: newCount };
    })
    .filter(Boolean);
};

export const removeAssetProductLinks = (state, {
  assetIds = [],
  products = [],
  productVariants = [],
}) => {
  if (!assetIds.length || (!products.length && !productVariants.length)) return state;

  const assetIdSet = new Set(assetIds.map(String));
  const selectedAffectedCount = assetIds.filter((id) => state.selectedItems.includes(id)).length;

  const items = state.items.map((asset) => {
    if (!assetIdSet.has(String(asset._id))) return asset;

    return {
      ...asset,
      products: filterProductLinks(asset.products || [], products),
      productVariants: filterVariantLinks(asset.productVariants || [], productVariants),
    };
  });

  if (!selectedAffectedCount) {
    return { ...state, items };
  }

  return {
    ...state,
    items,
    selectedAssetsAggregatedData: {
      ...state.selectedAssetsAggregatedData,
      products: decrementAggregatedProductLinks(
        state.selectedAssetsAggregatedData?.products || [],
        products,
        selectedAffectedCount,
      ),
      productVariants: decrementAggregatedVariantLinks(
        state.selectedAssetsAggregatedData?.productVariants || [],
        productVariants,
        selectedAffectedCount,
      ),
    },
  };
};

export default removeAssetProductLinks;
